var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleLogo = function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#DADCE0",
    rx: 19.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-logo_svg__clip0_9_55)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M20 14.276c1.397 0 2.649.482 3.636 1.421l2.703-2.704c-1.642-1.527-3.785-2.467-6.339-2.467a9.469 9.469 0 0 0-8.463 5.219l3.15 2.443c.746-2.246 2.842-3.912 5.313-3.912Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M29.071 20.217c0-.62-.06-1.22-.15-1.796H20v3.56h5.108a4.404 4.404 0 0 1-1.887 2.835l3.051 2.368c1.78-1.65 2.8-4.09 2.8-6.967Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M14.683 21.812c-.19-.573-.3-1.18-.3-1.812 0-.632.107-1.24.3-1.812l-3.15-2.443A9.44 9.44 0 0 0 10.526 20c0 1.532.364 2.976 1.01 4.255l3.147-2.443Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M20 29.474c2.558 0 4.71-.841 6.272-2.294l-3.05-2.368c-.85.572-1.943.908-3.222.908-2.471 0-4.567-1.666-5.317-3.912l-3.15 2.443c1.563 3.099 4.764 5.223 8.467 5.223Z"
  }))));
};
export default SvgGoogleLogo;